import Cookies from 'js-cookie';

const cookieName = 'cookies-accepted';

export function cookiesEnabled(): boolean {
  let cookieEnabled = Boolean(window.navigator.cookieEnabled);

  if (!cookieEnabled) {
    document.cookie = 'cookieTest';
    cookieEnabled = Boolean(document.cookie.indexOf('cookieTest') !== -1);
  }

  return cookieEnabled;
}

export function getCookieValue(name: string = cookieName): string | undefined {
  return Cookies.get(name);
}

export function createCookie(
  name: string = cookieName,
  value: string = '1',
  lifetime: number = 30,
) {
  return Cookies.set(name, value, {
    expires: lifetime,
  });
}
